<template>
  <div style="padding-top: 60px" :class="type == 1 ? '' : 'mod-bankcard mod-bankcryptowallet'">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$router.back()" class="header-back"></a>
      </div>
      <div class="header-center">
        <h4 class="header-title">{{ type == 1 ? '银行卡管理' : 'USDT钱包管理' }}</h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
        <!-- <a v-if="!$store.state.token" @click="$parent.goNav('/login')" class="header-action" id="login_btn" style="font-size: 12px">登录</a> -->
      </div>
    </div>
    <div class="mod-bankcard" v-if="type == 1">
      <div id="cardlist" class="p15">
        <div :class="`card-item pr bg-${index % 2 === 0 ? 1 : 2}`" v-for="(item, index) in usercardLis" :key="index">
          <i></i>
          <div class="bank-name">{{ item.bank }}</div>
          <div class="bank-info">
            <span style="font-size: 0.5rem">{{ item.bank_address }}</span>
            <span style="font-size: 0.5rem">{{ item.bank_owner }}</span>
          </div>
          <div class="bank-num">{{ item.bank_no }}</div>
          <div id="1303217" class="form-check" @click="showDel(item.id)">
            <img src="/static/image/delicos.png" style="width: 25px; margin-right: 20px; margin-top: 6px" alt="" />
          </div>
        </div>
        <div class="mtb30">
          <a href="javascript:void(0);" v-if="usercardLis.length < 5" id="addcard_btn" @click="$parent.goNav('/addBankCard')" class="addcard-btn"><em>+</em>新增银行卡</a>
        </div>
      </div>
    </div>
    <div class="mod-bankcard" v-if="type == 2">
      <div id="cardlist" class="p15">
        <div :class="`card-item pr bg-${index % 2 === 0 ? 1 : 2}`" v-for="(item, index) in usdssLis" :key="index">
          <i></i>
          <div class="bank-name">{{ item.bank }}</div>
          <div class="bank-info">
            <span style="font-size: 0.5rem">{{ item.bank_owner }}</span>
          </div>
          <div class="bank-num" style="letter-spacing: 0; word-break: break-word">{{ item.bank_no }}</div>
          <div id="1303217" class="form-check" @click="showDel(item.id)" style="position: absolute">
            <img src="/static/image/delicos.png" style="width: 25px; margin-right: 10px; margin-top: 16px; filter: brightness(0)" alt="" />
          </div>
        </div>
        <div class="mtb30">
          <a href="javascript:void(0);" v-if="usdssLis.length < 5" id="addcard_btn" @click="formShow = true" class="addcard-btn"><em>+</em>新增USDT</a>
        </div>
      </div>
    </div>
    <form id="form_card" method="post" style="z-index: 1000; display: block" class="popup popup-bankcryptowallet" v-if="formShow">
      <div class="popup-wrap">
        <div class="modal-hd">
          <h2>添加 USDT 钱包</h2>
        </div>
        <div class="login-wrap clearfix">
          <ul class="clearfix">
            <li>
              <label>提现地址<em>*</em></label>
              <div class="form-ipt">
                <input type="text" v-model="usdtInfo.bank_no" oninput="value=value.replace(/[\W]/g,'')" name="add_card_crypto" id="add_card_crypto" minlength="26" maxlength="42" class="txt-ipt cardnum" placeholder="请输入提现地址" />
              </div>
            </li>
            <p class="info_p">请直接复制钱包的地址，不要手动输入</p>
            <li>
              <label>选择协议<em>*</em></label>
              <div class="form-ipt">
                <div class="container-bankcode">
                  <a style="height: 30px; width: 60px; display: flex; align-items: center; justify-content: center; padding: 0; font-size: 0.24rem" :class="usdtInfo.bank_owner == 'TRC20' ? ' add_bankcode_crypto actic' : 'add_bankcode_crypto '" @click="changXie('TRC20')">TRC20</a>
                  <a style="height: 30px; width: 60px; display: flex; align-items: center; justify-content: center; padding: 0; font-size: 0.24rem" :class="usdtInfo.bank_owner == 'ERC20' ? ' add_bankcode_crypto actic' : 'add_bankcode_crypto '" @click="changXie('ERC20')"> ERC20</a>
                </div>
              </div>
            </li>
            <p class="info_p">请确保您的钱包地址支持此协议，如果对方平台不支持找回，您的资金将会丢失。</p>
            <li>
              <label>支付密码<em>*</em></label>
              <div class="form-ipt">
                <input type="password" autocomplete="new-password" v-model="usdtInfo.pay_pass" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" placeholder="请输入支付密码" class="txt-ipt cardnum" />
              </div>
            </li>
          </ul>

          <div class="tk_tips2">
            <p><b>温馨提示：</b>请您在相关注单结算完成后稍微耐心等待10-15分钟后系统会自动校正有效流水。详细有效流水规则请查看各游戏平台【天天返水】详情，感谢您的支持与信任！</p>
            <p><i></i>未参加任何优惠活动存款需投注1倍有效流水(全额投注额)即可提款，如参加活动亲参考活动红利流水详细规则。【如提款未成功，请留意站内信历史消息详细说明】感谢您的支持与信任.</p>
          </div>
        </div>
        <div class="bottom">
          <a id="close" href="javascript:void(0);" class="grey-button" @click="closeForm">取消</a>
          <a id="confirm_btn" class="orange-button" href="javascript:void(0);" @click="bindUsdss">确定</a>
        </div>
      </div>
      <div class="popup-mask" onclick="javascript:void(0);"><div class="popup-mask" onclick="javascript:void(0);"></div></div>
    </form>
            <van-dialog v-model="delShow" title="解绑卡片" show-cancel-button :before-close="delCard">
      <div style="padding: 10px;20px;background:rgb(251 248 248)">
        <van-cell-group>
          <van-field v-model="pay_pass" label="支付密码" type="password" placeholder="请输入6位数字支付密码" oninput="value=value.replace(/[^0-9]/g,'')" maxlength="6" />
        </van-cell-group>
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  name: 'wallet',
  data() {
    return {
      usercardLis: [],
      usdssLis: [],
      type: 1, // 1 银行卡  2 USDT
      formShow: false,
      usdtInfo: { bank_owner: 'TRC20' },
      pay_pass: null,
      delId: null,
      delShow: false,
    };
  },
  created() {
    let that = this;
    let query = that.$route.query;

    if (query.type) {
      that.type = query.type * 1;
    }
    if (query.show) {
      that.formShow = true;
    }
    that.getUsercard();
    that.getUsdssList();
  },
  methods: {
    closeForm() {
      this.usdtInfo = { bank_owner: 'TRC20' };
      this.formShow = false;
    },
    changXie(name) {
      this.usdtInfo.bank_owner = name;
      console.log(this.usdtInfo.bank_owner);
    },
    showDel(id) {
      let that = this;
      that.delId = id;
      that.pay_pass = null;
      that.delShow = true;
    },
    delCard(action, done) {
      let that = this;
      if (action === 'confirm') {
        let id = that.delId;
        let pay_pass = that.pay_pass;
        let paypasswordreg = /^[0-9]{6}$/; //只能是6位 数字
        if (paypasswordreg.test(pay_pass) == false) {
          that.$parent.showTost(0, '请输入6位数字支付密码');
          done(false);
          return;
        }
        that.$parent.showLoading();

        that.$apiFun.post('/api/delcard', { id, pay_pass }).then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }

          if (res.code == 200) {
            that.$parent.showTost(1, '解绑成功');

            that.getUsercard();
            that.getUsdssList();
          }
          that.$parent.hideLoading();

          done(true);
        });
      } else {
        done(true);
      }
    },

    getUsercard() {
      let that = this;
      this.$parent.showLoading();

      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.usercardLis = res.data;
        }
        this.$parent.hideLoading();
      });
    },
    getUsdssList() {
      let that = this;
      this.$parent.showLoading();

      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
        this.$parent.hideLoading();
      });
    },
    bindUsdss() {
      let that = this;
      let usdtInfo = that.usdtInfo;
      usdtInfo.bank = 'USDT';
      if (usdtInfo.bank_no == null || usdtInfo.bank_no == '') {
        that.$parent.showTost(0, '请输入USDT地址');
        return;
      }
      if (!usdtInfo.bank_owner || usdtInfo.bank_owner == null) {
        that.$parent.showTost(0, '请选择钱包协议');
        return;
      }
      if (!usdtInfo.pay_pass) {
        that.$parent.showTost(0, '请输人支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', usdtInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.getUsdssList();

            that.$parent.showTost(1, res.message);
            that.closeForm();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
#form_card .login-wrap .mod-forms label {
  padding-left: 30px;
  background: no-repeat 10px 10px;
  background-size: 22px;
}
#form_card .login-wrap .mod-forms li .form-ipt .txt-ipt {
  width: 85%;
}
@media (max-width: 320px) {
  #form_card .login-wrap .mod-forms li .form-ipt .txt-ipt {
    width: 80%;
  }
}
.actic {
  color: #ff914a !important;
  border: 1px solid #ff914a !important;
}
.current a {
  color: #ff914a;
}

.tab-content {
  display: none;
}

#tab-1 {
  display: block;
}

.tabs-menu li {
  display: inline;
}

.tabs-menu {
  font-size: 14px;
  font-weight: 600;
}

.current a {
  border-bottom: solid;
  border-bottom-color: rgb(255, 169, 0);
}

a.addcard-btn {
  width: 94%;
  height: 60px;
  line-height: 60px;
  color: #4b4b4b;
  box-shadow: 0 0 2px 0 rgb(0 0 0 / 10%);
  border-radius: 5px;
  border: 2px solid #e2e2e4;
  outline: 0;
  display: block;
  text-align: left;
  margin: 10px auto;
}
a.addcard-btn em {
  font-size: 18px;
  line-height: 1;
  margin-right: 5px;
  font-weight: 100;
  margin-left: 14px;
}
a.addcard-btn input {
  color: #4b4b4b;
  background: none;
  border: 0;
  font-size: 14px;
}
.mod-bankcryptowallet #tabs-container {
  overflow: hidden;
  max-width: 100%;
}
.mod-bankcryptowallet .card-wrap {
  max-width: 100%;
}
.mod-bankcryptowallet .tabs-menu {
  padding: 10px;
  top: 65px;
  width: 100%;
  z-index: 2;
  background: #fff;
}
.mod-bankcryptowallet .tabs-menu li a {
  padding: 10px;
  color: #a8a8a8;
  font-weight: normal;
}
.mod-bankcryptowallet .tabs-menu li.current a {
  color: #ffa954;
  position: relative;
  border: 0;
  font-size: 15px;
  border-bottom: 2px solid #ffa956;
}
.mod-bankcryptowallet .tab {
  position: relative;
}
.mod-bankcryptowallet .tab .layout {
  margin: 10px;
}
.mod-bankcryptowallet .card-item {
  max-width: 100%;
  background: #fff;
  padding: 10px 0;
  border-radius: 5px;
  color: #383838;
  transition: left 1s;
  left: 0;
  height: 80px;
  box-shadow: 0 0 2px 0 rgb(0 0 0 / 10%);
  border: 2px solid #e2e2e4;
}
.mod-bankcryptowallet .card-item.active {
  background: linear-gradient(to right, #fae1a9, #f3b467);
  color: #fff;
  box-shadow: 0 0 2px 0 #f9e2d2;
  border: 1px solid #f9e2d2;
}
.mod-bankcryptowallet .card-item.active > div.bank-name {
  color: #fff;
}
.mod-bankcryptowallet .card-item.active > div.bank-node {
  color: #fff;
}
.mod-bankcryptowallet .card-item:last-child {
  margin-bottom: 0;
}
.mod-bankcryptowallet .card-item > div {
  padding: 0 10px 0 20px;
  position: relative;
}
.mod-bankcryptowallet .card-item > div.bank-name {
  color: #383838;
  line-height: 25px;
  font-weight: bold;
}
.mod-bankcryptowallet .card-item > div.bank-name label {
  font-weight: normal;
}
.mod-bankcryptowallet .card-item > div.bank-name > em {
  font-size: 12px;
  vertical-align: top;
  font-weight: normal;
}
.mod-bankcryptowallet .card-item > div.bank-node {
  color: #5a5a5a;
  font-size: 12px;
}
.mod-bankcryptowallet .card-item > div.card-num {
  margin: 15px 15px 0 0;
  font-size: 12px;
  overflow: hidden;
  font-weight: bold;
}
.mod-bankcryptowallet .card-item > div.card-num input {
  border: 0;
  height: 25px;
  width: calc(100% - 30px);
}
.mod-bankcryptowallet .card-item .bank-edit {
  background: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/ico_edit.png) no-repeat center/25px;
  width: 25px;
  height: 25px;
  display: inline-block;
  position: absolute;
  right: 4%;
  bottom: 0;
}
.mod-bankcryptowallet .card-item .bank-edit.active {
  background: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/ico_saved.png) no-repeat center/25px;
}
.mod-bankcryptowallet .card-item .form-check {
  top: -10px;
  right: 2px;
}
/* 
.mod-bankcryptowallet .card-item .ui-switcher{box-shadow: none;height: 25px;width: 50px;border-radius: 15px;background:#ebebeb;}
.mod-bankcryptowallet .card-item .ui-switcher:after{left:25px;background:#cccccc;top:0;height: 25px;width: 25px;}
.mod-bankcryptowallet .card-item .ui-switcher[aria-checked=true]{background:#ffd5b8;}
.mod-bankcryptowallet .card-item .ui-switcher[aria-checked=true]:before{content:none;}
.mod-bankcryptowallet .card-item .ui-switcher[aria-checked=true]:after{background:#ff944b;}
.mod-bankcryptowallet .card-item .ui-switcher[aria-checked=false]:after {left:0px;}
.mod-bankcryptowallet .card-item .ui-switcher[aria-checked=false]:before{content:none;} */
.mod-bankcryptowallet #form_card h2 {
  display: block;
  background: #fff;
  color: #ff944b;
}
.mod-bankcryptowallet #form_card .login-wrap {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 60vh;
  padding: 0 5%;
  margin: 0;
}
.mod-bankcryptowallet #form_card .popup-wrap {
  max-height: 90vh;
  overflow: hidden;
}
.mod-bankcryptowallet .tk_tips2 {
  margin: 15px 0;
}
.mod-bankcryptowallet .tk_tips2 p {
  font-size: 12px;
  margin: 0;
}

.popup-bankcryptowallet .popup-wrap h2 {
  font-size: 20px;
  font-weight: normal;
  border-top: 0;
}
.popup-bankcryptowallet .popup-close {
  background: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/ico_close.png) no-repeat;
  background-size: 100% 100%;
  width: 16px;
  height: 16px;
  top: 17px;
}
.popup-bankcryptowallet .login-wrap li label {
  color: #5a5a5a;
  font-size: 13px;
}
.popup-bankcryptowallet .login-wrap li input {
  border-radius: 5px;
  font-size: 12px;
  width: 100%;
  border: 1px solid lightgrey;
  line-height: 30px;
  height: 30px;
  margin: 5px 0;
  text-indent: 5px;
}
.popup-bankcryptowallet .login-wrap li input::placeholder {
  color: #686868;
}
.popup-bankcryptowallet .login-wrap li em {
  font-size: 14px;
  color: #ff8624;
  position: relative;
  top: 2px;
  left: 0px;
  text-align: right;
}
.popup-bankcryptowallet .login-wrap .info_p {
  color: #ff944b;
  letter-spacing: 0;
  font-size: 12px;
  margin: 2px 0 15px 0;
}
.popup-bankcryptowallet .login-wrap select {
  background: #f0f0f0;
  border-radius: 5px;
  font-size: 14px;
  width: 100%;
  color: #a8a8a8;
  border: 0;
  line-height: 30px;
  height: 30px;
  padding: 0 5px;
  margin: 5px 0;
}
.popup-bankcryptowallet .login-wrap select select {
  background: #fff;
}
.popup-bankcryptowallet .remark_type {
  margin: 5px 0 10px 0;
}
.popup-bankcryptowallet .remark_type a {
  padding: 5px;
  background: #f0f0f0;
  border-radius: 2px;
  margin-right: 8px;
}
.popup-bankcryptowallet .remark_type a input {
  border: 0;
  background: 0;
  color: #808080;
}
.popup-bankcryptowallet .remark_type a.selected {
  background: #ff944b;
}
.popup-bankcryptowallet .remark_type a.selected input {
  color: #fff;
}
.popup-bankcryptowallet .mobile label,
.popup-bankcryptowallet .verify label {
  width: 75px;
  display: inline-flex;
}
.popup-bankcryptowallet .verify .form-ipt {
  width: calc(100% - 94px);
  display: inline-block;
  border-radius: 5px;
  border: 1px solid lightgrey;
}
.popup-bankcryptowallet .verify .form-ipt input {
  background: none;
}
.popup-bankcryptowallet .verify .form-ipt input.txt-ipt {
  width: calc(100% - 75px);
}
#mobile_code {
  border: 0;
}
.popup-bankcryptowallet .verify .form-ipt #verify_mobile_btn {
  color: #f7a915;
  font-size: 12px;
  text-indent: 0px;
  width: 68px;
  margin-right: 5px;
  float: right;
  border: 0;
}
.popup-bankcryptowallet .login-wrap li.mobile input {
  width: calc(100% - 95px);
}
.popup-bankcryptowallet .tk_tips2 p b {
  color: #222;
}
.popup-bankcryptowallet .login-wrap li .add_bankcode_crypto input {
  background: none;
  border: 0;
  line-height: normal;
  height: auto;
  margin: 0;
  color: #222;
}
.container-bankcode {
  width: 247px;
  height: 37px;
  margin-top: 4px;
}
.add_bankcode_crypto {
  float: left;
  width: auto;
  padding: 6px 15px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid #d1d1d1;
  margin-left: 3px;
  position: relative;
}
.selectedprotocol {
  color: #ff944b;
  border: 1px solid #ff944b;
}
.selectedprotocol:before {
  content: '';
  background: url(/static/image/icon_selected.png) no-repeat;
  background-size: 20px;
  width: 20px;
  height: 15px;
  position: absolute;
  right: -1px;
  bottom: -1px;
  border-radius: 0 0 5px;
}
.defaultcard-box {
  background: url(/static/image/wallet_untick.png) no-repeat right/30px;
  width: 30px;
  height: 30px;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/wallet.vue